const global_settings = {
  fields_tab: 'Campos personalizados de usuario',
  code_length: 'Longitud del código teclado',
  min_length: 'Longitud mínima',
  max_length: 'Longitud máxima',
  keypad_confirmation_msg:
    '¿Estás seguro de que deseas cambiar la longitud del código teclado de {{ initialKeypadCode }} a {{ keypadCode }}?',
  keypad_var_confirmation_msg:
    '¿Estás seguro de que deseas cambiar la longitud mínima y máxima del código teclado?',
  field_label: 'Etiqueta del campo',
  field_type: 'Tipo de campo',
  fields_confirmation_msg:
    '¿Estás seguro de que deseas guardar los cambios? Cualquier eliminación de campos personalizados afectará a los usuarios que los tenían.',
  fields_delete_msg:
    '¿Estás seguro de que deseas eliminar este campo personalizado? Se ha asignado a {{user_count}} usuarios.',
  fields_success: 'Campos personalizados guardados con éxito',
  keypad_success: 'Modificación realizada con éxito',
  keypad_error: 'Error al modificar',
  keypad_exists:
    'Hay usuarios con código de teclado, las modificaciones estarán limitadas.',
  add_new_field: 'Agregar nuevo campo',
  no_fields_configured: 'No hay campos personalizados configurados.',
  all_fields_removed:
    'Todos los campos fueron eliminados. Guarde para aplicar estos cambios.',
};

export default global_settings;
